import React from 'react';
import { FaYoutube } from 'react-icons/fa6';

const YOUTUBE_CHANNEL_URL = 'https://www.youtube.com/@surthrivaling';

const VIDEOS = [
  {
    title: 'Freedom Feels Different Than I Thought It Would',
    description:
      'I wanted fewer rules. I got fewer rules. Then I had to figure out what was hiding underneath them.',
    url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
  },
  {
    title: 'What Nobody Tells You About Being A Beginner At 40',
    description:
      'Starting over is easier when incompetence still feels age-appropriate. Later, it gets more interesting. By interesting, I mean rude.',
    url: 'https://www.youtube.com/watch?v=ysz5S6PUM-U',
  },
  {
    title: 'Why I Have Almost No Expat Friends In Bangkok',
    description:
      'Not because I dislike expats. I am one. That is part of the issue.',
    url: 'https://www.youtube.com/watch?v=jNQXAC9IVRw',
  },
];

function LatestVideos() {
  return (
    <section id="videos" className="section videos">
      <div className="container">
        <header className="section__header reveal">
          <h2 className="section__title">What&rsquo;s New On The &lsquo;Tube</h2>
          <p className="section__subtitle">
            This is where I yap a bit more about what&rsquo;s on my mind.
          </p>
        </header>

        <div className="videos__grid reveal reveal--delay-1">
          {VIDEOS.map((video) => (
            <a
              key={video.title}
              href={video.url}
              className="video-card"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="video-card__thumb" aria-hidden="true">
                <span className="video-card__play" />
              </div>
              <h3 className="video-card__title">{video.title}</h3>
              <p className="video-card__description">{video.description}</p>
              <span className="video-card__btn">Watch on YouTube</span>
            </a>
          ))}
        </div>

        <div className="videos__cta reveal reveal--delay-2">
          <a
            href={YOUTUBE_CHANNEL_URL}
            className="btn btn--accent videos__channel-btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaYoutube aria-hidden="true" />
            Channeling @Surthrivaling
          </a>
        </div>
      </div>
    </section>
  );
}

export default LatestVideos;
